import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const BonusSelect = styled(Select)`
  min-width: 180px;
`;
